'use strict';
const TOLERANCE = 3;

module.exports = function gridUp(domElement) {
	const elementPos = domElement.getBoundingClientRect(),
		siblings = Array.from(domElement.parentElement.children).filter(t => t !== domElement),
		siblingsAbove = siblings.filter(sibling => {
			const position = sibling.getBoundingClientRect();
			return elementPos.top > position.top && Math.abs(elementPos.left - position.left) < TOLERANCE;
		});
	siblingsAbove.sort((a, b) => b.getBoundingClientRect().top - a.getBoundingClientRect().top);
	return siblingsAbove[0] || domElement;
};
